import { useEffect, useState } from 'react';
import { Company, Rib, ReceivedCheck } from 'src/types/data';
import { useSelector } from 'react-redux';
import { selectFilteredData } from 'src/redux/selectors';

export function useCheckByCode(checkCode: string) {
  const data = useSelector(selectFilteredData);
  const [check, setCheck] = useState<ReceivedCheck | null>(null);
  const [company, setCompany] = useState<Company | null>(null);
  const [canEdit, setCanEdit] = useState(false);
  const [rib, setRib] = useState<Rib | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!checkCode || !data.length) {
      return;
    }

    // Use array methods instead of for loops
    data.find((comp: Company) =>
      comp.ribs.some((reb: Rib) => {
        const foundCheck = reb.recieved_checks.find((chk: ReceivedCheck) => chk.code === checkCode);
        if (foundCheck) {
          if (comp.user_role !== 'analysis') setCanEdit(true);
          setCheck(foundCheck);
          setCompany(comp);
          setRib(reb);
          return true;
        }
        return false;
      })
    );

    setIsLoading(false);
  }, [data, checkCode]);

  return { check, company, rib, canEdit, isLoading };
}

export function useCheckById(checkId: number) {
  const data = useSelector(selectFilteredData);

  const [check, setCheck] = useState<ReceivedCheck | null>(null);
  const [company, setCompany] = useState<Company | null>(null);
  const [rib, setRib] = useState<Rib | null>(null);
  const [canEdit, setCanEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!checkId || !data.length) {
      return;
    }

    // Use array methods instead of for loops
    data.find((comp: Company) =>
      comp.ribs.some((reb: Rib) => {
        const foundCheck = reb.recieved_checks.find((chk: ReceivedCheck) => chk.id === checkId);
        if (foundCheck) {
          if (comp.user_role !== 'analysis') setCanEdit(true);
          setCheck(foundCheck);
          setCompany(comp);
          setRib(reb);
          return true;
        }
        return false;
      })
    );

    setIsLoading(false);
  }, [data, checkId]);

  return { check, company, rib, canEdit, isLoading };
}
